var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _tspan35, _tspan36, _tspan37, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43, _tspan44, _tspan45, _tspan46, _tspan47;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMMemberPhones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-b1bd70f9-d9c6-49f9-a312-52d742b96be3",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 390 488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "351.006 .394 0 .394 0 447.917 390 447.917 390 88.373 351.006 .394",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(20.465 30.501)",
    style: {
      fontSize: 18
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#333",
      fontFamily: "Apparat-Regular, Apparat"
    }
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.53,
    y: 0,
    style: {
      fill: "#333",
      fontFamily: "Apparat-Regular, Apparat",
      letterSpacing: "-.022em"
    }
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.846,
    y: 0,
    style: {
      fill: "#333",
      fontFamily: "Apparat-Regular, Apparat",
      letterSpacing: "-.003em"
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.936,
    y: 0,
    style: {
      fill: "#333",
      fontFamily: "Apparat-Regular, Apparat"
    }
  }, "lusi"), /*#__PURE__*/React.createElement("tspan", {
    x: 55.547,
    y: 0,
    style: {
      fill: "#333",
      fontFamily: "Apparat-Regular, Apparat",
      letterSpacing: "0em"
    }
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 64.025,
    y: 0,
    style: {
      fill: "#333",
      fontFamily: "Apparat-Regular, Apparat"
    }
  }, "e "), /*#__PURE__*/React.createElement("tspan", {
    x: 78.047,
    y: 0,
    style: {
      fill: "#333",
      fontFamily: "Apparat-Regular, Apparat",
      letterSpacing: "-.02em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.401,
    y: 0,
    style: {
      fill: "#333",
      fontFamily: "Apparat-Regular, Apparat"
    }
  }, "o "), /*#__PURE__*/React.createElement("tspan", {
    x: 99.341,
    y: 0,
    style: {
      fill: "#333",
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: ".003em"
    }
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    x: 110.699,
    y: 0,
    style: {
      fill: "#333",
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "eNXT "), /*#__PURE__*/React.createElement("tspan", {
    x: 162.053,
    y: 0,
    style: {
      fill: "#f7931e",
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.003em"
    }
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    x: 175.967,
    y: 0,
    style: {
      fill: "#f7931e",
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "OLD"), /*#__PURE__*/React.createElement("tspan", {
    x: 214.612,
    y: 0,
    style: {
      fill: "#f7931e",
      fontFamily: "Apparat-Regular, Apparat"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 218.752,
    y: 0,
    style: {
      fill: "#333",
      fontFamily: "Apparat-Regular, Apparat",
      letterSpacing: "-.001em"
    }
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 235.222,
    y: 0,
    style: {
      fill: "#333",
      fontFamily: "Apparat-Regular, Apparat"
    }
  }, "embe"), /*#__PURE__*/React.createElement("tspan", {
    x: 281.913,
    y: 0,
    style: {
      fill: "#333",
      fontFamily: "Apparat-Regular, Apparat",
      letterSpacing: ".007em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 288.735,
    y: 0,
    style: {
      fill: "#333",
      fontFamily: "Apparat-Regular, Apparat"
    }
  }, "s")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(20.465 56.792)",
    style: {
      fill: "#666",
      fontFamily: "Apparat-Light, Apparat",
      fontSize: 15
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Of")), /*#__PURE__*/React.createElement("tspan", {
    x: 17.58,
    y: 0,
    style: {
      letterSpacing: "-.011em"
    }
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.575,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "er empl"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.83,
    y: 0,
    style: {
      letterSpacing: "-.001em"
    }
  }, "oy"), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 89.85,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("tspan", {
    x: 98.04,
    y: 0,
    style: {
      letterSpacing: ".008em"
    }
  }, "e"), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 106.35,
    y: 0
  }, "s the p")), /*#__PURE__*/React.createElement("tspan", {
    x: 150.823,
    y: 0,
    style: {
      letterSpacing: "-.011em"
    }
  }, "r"), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 156.089,
    y: 0
  }, "emium benefit ")), /*#__PURE__*/React.createElement("tspan", {
    x: 258.837,
    y: 0,
    style: {
      letterSpacing: "-.004em"
    }
  }, "o"), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 267.657,
    y: 0
  }, "f ")), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18,
    style: {
      letterSpacing: "-.005em"
    }
  }, "c"), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 7.485,
    y: 18
  }, "oncie")), /*#__PURE__*/React.createElement("tspan", {
    x: 44.52,
    y: 18,
    style: {
      letterSpacing: "-.024em"
    }
  }, "r"), _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 49.59,
    y: 18
  }, "ge ")), /*#__PURE__*/React.createElement("tspan", {
    x: 69.945,
    y: 18,
    style: {
      letterSpacing: "-.001em"
    }
  }, "s"), _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 76.364,
    y: 18
  }, "e")), /*#__PURE__*/React.createElement("tspan", {
    x: 84.554,
    y: 18,
    style: {
      letterSpacing: ".013em"
    }
  }, "r"), _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 90.179,
    y: 18
  }, "vi")), /*#__PURE__*/React.createElement("tspan", {
    x: 100.634,
    y: 18,
    style: {
      letterSpacing: "-.005em"
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 108.119,
    y: 18,
    style: {
      letterSpacing: ".008em"
    }
  }, "e"), _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 116.429,
    y: 18
  }, "s ")), /*#__PURE__*/React.createElement("tspan", {
    x: 126.313,
    y: 18,
    style: {
      letterSpacing: ".007em"
    }
  }, "a"), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 134.068,
    y: 18
  }, "t a f")), /*#__PURE__*/React.createElement("tspan", {
    x: 159.132,
    y: 18,
    style: {
      letterSpacing: "-.016em"
    }
  }, "r"), _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 164.323,
    y: 18
  }, "a")), /*#__PURE__*/React.createElement("tspan", {
    x: 171.973,
    y: 18,
    style: {
      letterSpacing: "-.002em"
    }
  }, "c"), _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 179.503,
    y: 18
  }, "tion ")), /*#__PURE__*/React.createElement("tspan", {
    x: 209.592,
    y: 18,
    style: {
      letterSpacing: "-.004em"
    }
  }, "o"), _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 218.412,
    y: 18
  }, "f the insu")), /*#__PURE__*/React.createElement("tspan", {
    x: 280.391,
    y: 18,
    style: {
      letterSpacing: "-.016em"
    }
  }, "r"), _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 285.581,
    y: 18
  }, "an")), /*#__PURE__*/React.createElement("tspan", {
    x: 302.066,
    y: 18,
    style: {
      letterSpacing: "-.005em"
    }
  }, "c"), _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 309.551,
    y: 18
  }, "e ")), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 36,
    style: {
      letterSpacing: "-.005em"
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.485,
    y: 36,
    style: {
      letterSpacing: "-.001em"
    }
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.35,
    y: 36,
    style: {
      letterSpacing: "-.002em"
    }
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.755,
    y: 36,
    style: {
      letterSpacing: ".02em"
    }
  }, "t"), _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 28.41,
    y: 36
  }, ". H")), /*#__PURE__*/React.createElement("tspan", {
    x: 46.319,
    y: 36,
    style: {
      letterSpacing: "-.001em"
    }
  }, "av"), _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 60.824,
    y: 36
  }, "e ")), /*#__PURE__*/React.createElement("tspan", {
    x: 72.464,
    y: 36,
    style: {
      letterSpacing: "-.007em"
    }
  }, "v"), _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 79.244,
    y: 36
  }, "aluable ")), /*#__PURE__*/React.createElement("tspan", {
    x: 130.782,
    y: 36,
    style: {
      letterSpacing: ".005em"
    }
  }, "p"), _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 139.617,
    y: 36
  }, "a")), /*#__PURE__*/React.createElement("tspan", {
    x: 147.267,
    y: 36,
    style: {
      letterSpacing: ".013em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 152.892,
    y: 36,
    style: {
      letterSpacing: ".005em"
    }
  }, "t"), _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 158.322,
    y: 36
  }, "-time empl")), /*#__PURE__*/React.createElement("tspan", {
    x: 232.346,
    y: 36,
    style: {
      letterSpacing: "-.001em"
    }
  }, "oy"), _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 248.366,
    y: 36
  }, "e")), /*#__PURE__*/React.createElement("tspan", {
    x: 256.556,
    y: 36,
    style: {
      letterSpacing: ".008em"
    }
  }, "e"), _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 264.865,
    y: 36
  }, "s or ")), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 54,
    style: {
      letterSpacing: "-.005em"
    }
  }, "c"), _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 7.485,
    y: 54
  }, "ont")), /*#__PURE__*/React.createElement("tspan", {
    x: 30.555,
    y: 54,
    style: {
      letterSpacing: "-.016em"
    }
  }, "r"), _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 35.745,
    y: 54
  }, "a")), /*#__PURE__*/React.createElement("tspan", {
    x: 43.395,
    y: 54,
    style: {
      letterSpacing: "-.002em"
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 50.925,
    y: 54,
    style: {
      letterSpacing: "-.022em"
    }
  }, "t"), _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 55.951,
    y: 54
  }, "o")), /*#__PURE__*/React.createElement("tspan", {
    x: 64.831,
    y: 54,
    style: {
      letterSpacing: ".005em"
    }
  }, "r"), _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 70.335,
    y: 54
  }, "s th")), /*#__PURE__*/React.createElement("tspan", {
    x: 94.41,
    y: 54,
    style: {
      letterSpacing: ".007em"
    }
  }, "a"), _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 102.165,
    y: 54
  }, "t a")), /*#__PURE__*/React.createElement("tspan", {
    x: 118.619,
    y: 54,
    style: {
      letterSpacing: "-.011em"
    }
  }, "r"), _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 123.884,
    y: 54
  }, "en&apos;t eligible ")), /*#__PURE__*/React.createElement("tspan", {
    x: 204.072,
    y: 54,
    style: {
      letterSpacing: "-.011em"
    }
  }, "f"), _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 209.067,
    y: 54
  }, "or benefi")), /*#__PURE__*/React.createElement("tspan", {
    x: 269.532,
    y: 54,
    style: {
      letterSpacing: ".004em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 274.946,
    y: 54,
    style: {
      letterSpacing: "0em"
    }
  }, "s"), _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 281.366,
    y: 54
  }, "? L")), /*#__PURE__*/React.createElement("tspan", {
    x: 299.605,
    y: 54,
    style: {
      letterSpacing: ".002em"
    }
  }, "e"), _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 307.825,
    y: 54
  }, "t&apos;s ")), _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 72
  }, "g")), /*#__PURE__*/React.createElement("tspan", {
    x: 8.715,
    y: 72,
    style: {
      letterSpacing: ".002em"
    }
  }, "e"), _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 16.935,
    y: 72
  }, "t them ")), /*#__PURE__*/React.createElement("tspan", {
    x: 65.234,
    y: 72,
    style: {
      letterSpacing: "-.005em"
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 72.719,
    y: 72,
    style: {
      letterSpacing: "0em"
    }
  }, "ov"), _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 88.454,
    y: 72
  }, "e")), /*#__PURE__*/React.createElement("tspan", {
    x: 96.644,
    y: 72,
    style: {
      letterSpacing: "-.011em"
    }
  }, "r"), _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 101.91,
    y: 72
  }, "ed ")), /*#__PURE__*/React.createElement("tspan", {
    x: 122.279,
    y: 72,
    style: {
      letterSpacing: "-.022em"
    }
  }, "t"), _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 127.304,
    y: 72
  }, "o")), /*#__PURE__*/React.createElement("tspan", {
    x: 136.184,
    y: 72,
    style: {
      letterSpacing: "-.019em"
    }
  }, "o"), _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 144.779,
    y: 72
  }, "."))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(42.29 161.725)",
    style: {
      fill: "#333",
      fontSize: "14.134px"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      letterSpacing: ".017em"
    }
  }, "S"), _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 7.985,
    y: 0
  }, "ame-d")), /*#__PURE__*/React.createElement("tspan", {
    x: 49.297,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "a"), _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 56.491,
    y: 0
  }, "y / ")), /*#__PURE__*/React.createElement("tspan", {
    x: 74.794,
    y: 0,
    style: {
      letterSpacing: "-.006em"
    }
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    x: 85.945,
    y: 0,
    style: {
      letterSpacing: "-.012em"
    }
  }, "e"), _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 93.493,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("tspan", {
    x: 99.923,
    y: 0,
    style: {
      letterSpacing: ".005em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 105.039,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "-d"), /*#__PURE__*/React.createElement("tspan", {
    x: 118.551,
    y: 0,
    style: {
      letterSpacing: "-.001em"
    }
  }, "a"), _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 125.745,
    y: 0
  }, "y Appointmen")), /*#__PURE__*/React.createElement("tspan", {
    x: 215.379,
    y: 0,
    style: {
      letterSpacing: ".004em"
    }
  }, "t"), _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 220.481,
    y: 0
  }, "s"))), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24.812,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "Appointmen"), /*#__PURE__*/React.createElement("tspan", {
    x: 79.627,
    y: 24.812,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: ".025em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 85.026,
    y: 24.812,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, ", Reimbu"), /*#__PURE__*/React.createElement("tspan", {
    x: 140.359,
    y: 24.812,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: ".005em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 145.545,
    y: 24.812,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "0em"
    }
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 151.595,
    y: 24.812,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "ement "), /*#__PURE__*/React.createElement("tspan", {
    x: 196.524,
    y: 24.812,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.021em"
    }
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 204.877,
    y: 24.812,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "0em"
    }
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 213.471,
    y: 24.812,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: ".019em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 219.223,
    y: 24.812,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: ".006em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 224.947,
    y: 24.812,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "0em"
    }
  }, "al"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: ".013em"
    }
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.286,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.005em"
    }
  }, "cc"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.391,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: ".008em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.221,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.002em"
    }
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.256,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "s "), /*#__PURE__*/React.createElement("tspan", {
    x: 46.569,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.022em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 51.304,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "o "), /*#__PURE__*/React.createElement("tspan", {
    x: 62.922,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 68.434,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.011em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 77.593,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, ",000+ "), /*#__PURE__*/React.createElement("tspan", {
    x: 122.127,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.005em"
    }
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    x: 132.854,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.002em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 140.741,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "alth"), /*#__PURE__*/React.createElement("tspan", {
    x: 166.336,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.002em"
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 173.389,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "0em"
    }
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 180.865,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.01em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 186.208,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "e Speciali"), /*#__PURE__*/React.createElement("tspan", {
    x: 248.309,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.005em"
    }
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 254.669,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: ".005em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 260.379,
    y: 49.625,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 74.437,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.005em"
    }
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.166,
    y: 74.437,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "o "), /*#__PURE__*/React.createElement("tspan", {
    x: 23.009,
    y: 74.437,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "Insu"), /*#__PURE__*/React.createElement("tspan", {
    x: 49.509,
    y: 74.437,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.016em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 54.399,
    y: 74.437,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "an"), /*#__PURE__*/React.createElement("tspan", {
    x: 69.932,
    y: 74.437,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.005em"
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 76.985,
    y: 74.437,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "e Requi"), /*#__PURE__*/React.createElement("tspan", {
    x: 124.062,
    y: 74.437,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.011em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 129.024,
    y: 74.437,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "ed"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 99.249,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.11em"
    }
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.869,
    y: 99.249,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "eleh"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.178,
    y: 99.249,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.002em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.065,
    y: 99.249,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "alth "), /*#__PURE__*/React.createElement("tspan", {
    x: 71.911,
    y: 99.249,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "or "), /*#__PURE__*/React.createElement("tspan", {
    x: 88.645,
    y: 99.249,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "In-pe"), /*#__PURE__*/React.createElement("tspan", {
    x: 123.371,
    y: 99.249,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: ".006em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 128.939,
    y: 99.249,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.005em"
    }
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 135.299,
    y: 99.249,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "0em"
    }
  }, "on"), /*#__PURE__*/React.createElement("tspan", {
    x: 152.471,
    y: 99.249,
    xmlSpace: "preserve",
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "0em"
    }
  }, " Appointmen"), /*#__PURE__*/React.createElement("tspan", {
    x: 235.349,
    y: 99.249,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: ".004em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 240.451,
    y: 99.249,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 124.062,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "100%"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.076,
    y: 124.062,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 41.326,
    y: 124.062,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.004em"
    }
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 49.368,
    y: 124.062,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "0em"
    }
  }, "ri"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.848,
    y: 124.062,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.005em"
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 64.901,
    y: 124.062,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "e "), /*#__PURE__*/React.createElement("tspan", {
    x: 75.869,
    y: 124.062,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.094em"
    }
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 82.737,
    y: 124.062,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.016em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 87.627,
    y: 124.062,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "ans"), /*#__PURE__*/React.createElement("tspan", {
    x: 109.223,
    y: 124.062,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: ".005em"
    }
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 117.548,
    y: 124.062,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 124.756,
    y: 124.062,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.011em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 129.717,
    y: 124.062,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "ency "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "$5 "), /*#__PURE__*/React.createElement("tspan", {
    x: 19.914,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.168,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.011em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.129,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: ".008em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.959,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.001em"
    }
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 47.008,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "0em"
    }
  }, "cri"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.611,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.003em"
    }
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.823,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "0em"
    }
  }, "tions with "), /*#__PURE__*/React.createElement("tspan", {
    x: 135.285,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 140.754,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.01em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 146.097,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.002em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 153.983,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "e "), /*#__PURE__*/React.createElement("tspan", {
    x: 165.149,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "0em"
    }
  }, "deli"), /*#__PURE__*/React.createElement("tspan", {
    x: 187.818,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.001em"
    }
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 194.292,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 202.008,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: ".022em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 207.436,
    y: 148.874,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "0em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.526,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "5-"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.854,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: ".005em"
    }
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.358,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "5% "), /*#__PURE__*/React.createElement("tspan", {
    x: 51.544,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 59.756,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.017em"
    }
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    x: 65.946,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.002em"
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.041,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "lusi"), /*#__PURE__*/React.createElement("tspan", {
    x: 94.029,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.001em"
    }
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 100.502,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "e Di"), /*#__PURE__*/React.createElement("tspan", {
    x: 125.462,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.001em"
    }
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 131.511,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.005em"
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 138.563,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "oun"), /*#__PURE__*/React.createElement("tspan", {
    x: 163.452,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: ".004em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 168.555,
    y: 173.686,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "s "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 198.498,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.089em"
    }
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.939,
    y: 198.498,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "ap in"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.34,
    y: 198.498,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      letterSpacing: "-.022em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.075,
    y: 198.498,
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, "o "), /*#__PURE__*/React.createElement("tspan", {
    x: 53.693,
    y: 198.498,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "Nationwide "), /*#__PURE__*/React.createElement("tspan", {
    x: 133.49,
    y: 198.498,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.005em"
    }
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    x: 144.655,
    y: 198.498,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.002em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 152.542,
    y: 198.498,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: ".009em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 158.308,
    y: 198.498,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      letterSpacing: "-.008em"
    }
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 168.979,
    y: 198.498,
    style: {
      fontFamily: "Apparat-Bold, Apparat"
    }
  }, "ork"), /*#__PURE__*/React.createElement("tspan", {
    x: 190.871,
    y: 198.498,
    xmlSpace: "preserve",
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontFamily: "Apparat-Light, Apparat"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 223.311,
    style: {
      letterSpacing: ".012em"
    }
  }, "A"), _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 9.271,
    y: 223.311
  }, "nd mo")), /*#__PURE__*/React.createElement("tspan", {
    x: 50.315,
    y: 223.311,
    style: {
      letterSpacing: "-.011em"
    }
  }, "r"), _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 55.276,
    y: 223.311
  }, "e\u2026")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.303,155.402l3.611,3.223-1.549,.269c.212-.27,.412-.511,.621-.76l.629-.732c.423-.483,.855-.957,1.296-1.423,.882-.931,1.799-1.828,2.768-2.67,.97-.839,1.991-1.629,3.102-2.279,.557-.321,1.136-.609,1.745-.817,.607-.206,1.249-.334,1.88-.291-.631,.048-1.225,.262-1.774,.542-.55,.283-1.06,.635-1.544,1.017-.965,.771-1.828,1.664-2.637,2.599-.808,.938-1.561,1.924-2.275,2.936-.357,.506-.703,1.02-1.039,1.539l-.496,.782c-.16,.259-.325,.53-.468,.779l-.508,.888-1.04-.619-4.159-2.475,1.838-2.506Z",
    style: {
      fill: "#0379a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.303,180.354l3.611,3.223-1.549,.269c.212-.27,.412-.511,.621-.76l.629-.732c.423-.483,.855-.958,1.296-1.423,.882-.931,1.799-1.828,2.768-2.67,.97-.839,1.991-1.629,3.102-2.279,.557-.321,1.136-.609,1.745-.817,.607-.206,1.249-.334,1.88-.29-.631,.048-1.225,.262-1.774,.542-.55,.283-1.06,.635-1.544,1.017-.965,.771-1.828,1.664-2.637,2.599-.808,.938-1.561,1.924-2.275,2.936-.357,.506-.703,1.02-1.039,1.538l-.496,.782c-.16,.259-.325,.53-.468,.779l-.508,.888-1.04-.619-4.159-2.475,1.838-2.506Z",
    style: {
      fill: "#0379a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.303,205.306l3.611,3.223-1.549,.269c.212-.27,.412-.511,.621-.76l.629-.732c.423-.483,.855-.957,1.296-1.423,.882-.931,1.799-1.828,2.768-2.67,.97-.839,1.991-1.629,3.102-2.279,.557-.321,1.136-.609,1.745-.817,.607-.206,1.249-.334,1.88-.291-.631,.048-1.225,.262-1.774,.542-.55,.283-1.06,.635-1.544,1.017-.965,.771-1.828,1.664-2.637,2.6-.808,.938-1.561,1.924-2.275,2.936-.357,.506-.703,1.02-1.039,1.539l-.496,.782c-.16,.259-.325,.53-.468,.779l-.508,.888-1.04-.619-4.159-2.475,1.838-2.506Z",
    style: {
      fill: "#0379a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.303,230.258l3.611,3.223-1.549,.269c.212-.27,.412-.511,.621-.76l.629-.732c.423-.483,.855-.958,1.296-1.423,.882-.931,1.799-1.828,2.768-2.67,.97-.839,1.991-1.629,3.102-2.279,.557-.321,1.136-.609,1.745-.817,.607-.206,1.249-.334,1.88-.291-.631,.048-1.225,.262-1.774,.542-.55,.283-1.06,.635-1.544,1.017-.965,.771-1.828,1.664-2.637,2.599-.808,.938-1.561,1.924-2.275,2.936-.357,.506-.703,1.02-1.039,1.538l-.496,.782c-.16,.259-.325,.53-.468,.779l-.508,.888-1.04-.619-4.159-2.475,1.838-2.506Z",
    style: {
      fill: "#0379a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.303,255.21l3.611,3.223-1.549,.269c.212-.27,.412-.511,.621-.76l.629-.732c.423-.483,.855-.958,1.296-1.423,.882-.931,1.799-1.828,2.768-2.67,.97-.839,1.991-1.629,3.102-2.279,.557-.321,1.136-.609,1.745-.817,.607-.206,1.249-.334,1.88-.291-.631,.048-1.225,.262-1.774,.542-.55,.283-1.06,.635-1.544,1.017-.965,.771-1.828,1.664-2.637,2.6-.808,.938-1.561,1.924-2.275,2.936-.357,.506-.703,1.02-1.039,1.539l-.496,.782c-.16,.259-.325,.53-.468,.779l-.508,.888-1.04-.619-4.159-2.475,1.838-2.506Z",
    style: {
      fill: "#0379a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.303,280.162l3.611,3.223-1.549,.269c.212-.27,.412-.511,.621-.76l.629-.732c.423-.483,.855-.958,1.296-1.423,.882-.931,1.799-1.828,2.768-2.67,.97-.839,1.991-1.629,3.102-2.279,.557-.321,1.136-.609,1.745-.817,.607-.206,1.249-.334,1.88-.291-.631,.048-1.225,.262-1.774,.542-.55,.283-1.06,.635-1.544,1.017-.965,.771-1.828,1.664-2.637,2.599-.808,.938-1.561,1.924-2.275,2.936-.357,.506-.703,1.02-1.039,1.538l-.496,.782c-.16,.259-.325,.53-.468,.779l-.508,.888-1.04-.619-4.159-2.475,1.838-2.506Z",
    style: {
      fill: "#0379a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.303,305.114l3.611,3.223-1.549,.269c.212-.27,.412-.511,.621-.76l.629-.732c.423-.483,.855-.958,1.296-1.423,.882-.931,1.799-1.828,2.768-2.67,.97-.839,1.991-1.629,3.102-2.279,.557-.321,1.136-.609,1.745-.817,.607-.206,1.249-.334,1.88-.29-.631,.048-1.225,.262-1.774,.542-.55,.283-1.06,.635-1.544,1.017-.965,.771-1.828,1.664-2.637,2.599-.808,.938-1.561,1.924-2.275,2.936-.357,.506-.703,1.02-1.039,1.539l-.496,.782c-.16,.259-.325,.53-.468,.779l-.508,.888-1.04-.619-4.159-2.475,1.838-2.506Z",
    style: {
      fill: "#0379a6"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.303,330.066l3.611,3.223-1.549,.269c.212-.27,.412-.511,.621-.76l.629-.732c.423-.483,.855-.958,1.296-1.423,.882-.931,1.799-1.828,2.768-2.67,.97-.839,1.991-1.629,3.102-2.279,.557-.321,1.136-.609,1.745-.817,.607-.206,1.249-.334,1.88-.29-.631,.048-1.225,.262-1.774,.542-.55,.283-1.06,.635-1.544,1.017-.965,.771-1.828,1.664-2.637,2.599-.808,.938-1.561,1.924-2.275,2.936-.357,.506-.703,1.02-1.039,1.538l-.496,.782c-.16,.259-.325,.53-.468,.779l-.508,.888-1.04-.619-4.159-2.475,1.838-2.506Z",
    style: {
      fill: "#0379a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.303,355.018l3.611,3.223-1.549,.269c.212-.27,.412-.511,.621-.76l.629-.732c.423-.483,.855-.957,1.296-1.423,.882-.931,1.799-1.828,2.768-2.67,.97-.839,1.991-1.629,3.102-2.279,.557-.321,1.136-.609,1.745-.817,.607-.206,1.249-.334,1.88-.291-.631,.048-1.225,.262-1.774,.542-.55,.283-1.06,.635-1.544,1.017-.965,.771-1.828,1.664-2.637,2.6-.808,.938-1.561,1.924-2.275,2.936-.357,.506-.703,1.02-1.039,1.539l-.496,.782c-.16,.259-.325,.53-.468,.779l-.508,.888-1.04-.619-4.159-2.475,1.838-2.506Z",
    style: {
      fill: "#0379a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.303,379.97l3.611,3.223-1.549,.269c.212-.27,.412-.511,.621-.76l.629-.732c.423-.483,.855-.958,1.296-1.423,.882-.931,1.799-1.828,2.768-2.67,.97-.839,1.991-1.629,3.102-2.279,.557-.321,1.136-.609,1.745-.817,.607-.206,1.249-.334,1.88-.291-.631,.048-1.225,.262-1.774,.542-.55,.283-1.06,.635-1.544,1.017-.965,.771-1.828,1.664-2.637,2.599-.808,.938-1.561,1.924-2.275,2.936-.357,.506-.703,1.02-1.039,1.538l-.496,.782c-.16,.259-.325,.53-.468,.779l-.508,.888-1.04-.619-4.159-2.475,1.838-2.506Z",
    style: {
      fill: "#0379a6"
    }
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(20.465 422.562)",
    style: {
      fill: "#0071bc"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      fontSize: "20.994px",
      letterSpacing: ".004em"
    }
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.26,
    y: 0,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      fontSize: "20.994px",
      letterSpacing: "-.003em"
    }
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.303,
    y: 0,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      fontSize: "20.994px",
      letterSpacing: "-.011em"
    }
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.82,
    y: 0,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      fontSize: "20.994px",
      letterSpacing: "0em"
    }
  }, "e "), /*#__PURE__*/React.createElement("tspan", {
    x: 50.405,
    y: 0,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      fontSize: "20.994px",
      letterSpacing: "0em"
    }
  }, "up "), /*#__PURE__*/React.createElement("tspan", {
    x: 79.67,
    y: 0,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      fontSize: "20.994px",
      letterSpacing: "-.022em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 86.703,
    y: 0,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      fontSize: "20.994px"
    }
  }, "o "), /*#__PURE__*/React.createElement("tspan", {
    x: 103.959,
    y: 0,
    style: {
      fontFamily: "Apparat-Bold, Apparat",
      fontSize: "20.994px",
      letterSpacing: "0em"
    }
  }, "$500"), /*#__PURE__*/React.createElement("tspan", {
    x: 156.38,
    y: 0,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      fontSize: "20.994px",
      letterSpacing: "0em"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 161.208,
    y: 0,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      fontSize: "13.05px",
      letterSpacing: "0em"
    }
  }, "pe"), /*#__PURE__*/React.createElement("tspan", {
    x: 175.955,
    y: 0,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      fontSize: "13.05px",
      letterSpacing: "-.01em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 180.549,
    y: 0,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      fontSize: "13.05px",
      letterSpacing: "-.001em"
    }
  }, "-y"), /*#__PURE__*/React.createElement("tspan", {
    x: 191.642,
    y: 0,
    style: {
      fontFamily: "Apparat-Light, Apparat",
      fontSize: "13.05px"
    }
  }, "ear"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(20.465 474.187)",
    style: {
      fill: "#333",
      fontFamily: "Apparat-Regular, Apparat",
      fontSize: 14
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      letterSpacing: ".004em"
    }
  }, "B"), _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 8.652,
    y: 0
  }, "ooking any Appointment ")), /*#__PURE__*/React.createElement("tspan", {
    x: 170.391,
    y: 0,
    style: {
      letterSpacing: "-.005em"
    }
  }, "c"), _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 177.434,
    y: 0
  }, "ouldn\u2019t be simpler"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMMemberPhones);
export default __webpack_public_path__ + "static/media/MMemberPhones.23a57c7c7e023ba6171b3a5cd4347950.svg";
export { ForwardRef as ReactComponent };